import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { verificarSessoesAtivas, salvarSnapshotConflito } from '../utils/sessionGuard';
import logoKzero from '../assets/kzero-logo-color.png';

// O mesmo app atende dois públicos, separados pelo endereço de acesso:
// aluno.kzeroconsultoria.com.br e consultor.kzeroconsultoria.com.br (16/10/2026).
// O endereço antigo (kzerodiary.vercel.app) segue como o do consultor.
export function identidadeDoPortal() {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host.startsWith('aluno.')) {
    return {
      titulo: 'Portal do Aluno', subtitulo: 'Cursos e trilhas da Kzero Consultoria', aba: 'Portal do Aluno · Kzero',
      fundo: 'linear-gradient(150deg,#071033 0%,#0b1f6b 55%,#1d3fd1 100%)', destaque: '#93c5fd', botao: '#1d3fd1',
      frases: ['Seus cursos e trilhas em um só lugar', 'Estude no seu ritmo, de onde estiver', 'Acompanhe o seu progresso'],
    };
  }
  return {
    titulo: 'Portal do Consultor', subtitulo: 'Gestão de consultoria da Kzero', aba: 'Portal do Consultor · Kzero',
    fundo: 'linear-gradient(150deg,#1e0b3a 0%,#2e1065 55%,#4c1d95 100%)', destaque: '#c4b5fd', botao: '#5b21b6',
    frases: ['Clientes, agenda e projetos', 'Documentos e auditorias', 'Toda a consultoria em um só lugar'],
  };
}

// Estilos que dependem de foco e de largura de tela (inline não cobre).
const CSS_LOGIN = `
.kz-login{min-height:100vh;display:flex;background:#f4f6fb;font-family:inherit}
.kz-painel{flex:1 1 52%;color:#fff;position:relative;overflow:hidden;display:flex;flex-direction:column;justify-content:center;padding:56px 72px;font-family:'Segoe UI',Inter,system-ui,-apple-system,Arial,sans-serif}
.kz-painel .kz-circ{position:absolute;border-radius:50%;background:rgba(255,255,255,.08)}
.kz-painel .c1{width:460px;height:460px;right:-150px;top:-160px}
.kz-painel .c2{width:320px;height:320px;left:-120px;bottom:-130px}
.kz-painel img{height:auto;width:min(100%,320px);max-height:120px;object-fit:contain;object-position:left;filter:brightness(0) invert(1);align-self:flex-start;position:relative;transform:translateX(-10%)}
.kz-painel h1{font-family:'Segoe UI',Inter,system-ui,-apple-system,Arial,sans-serif;font-size:44px;line-height:1.1;font-weight:600;margin:40px 0 10px;position:relative;letter-spacing:-.3px}
.kz-painel p.kz-sub{font-size:18px;opacity:.9;margin:0 0 32px;position:relative}
.kz-painel ul{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:14px;position:relative}
.kz-painel li{font-size:16px;display:flex;align-items:center;gap:12px}
.kz-painel li span.kz-ok{width:26px;height:26px;border-radius:50%;background:rgba(255,255,255,.15);display:inline-flex;align-items:center;justify-content:center;font-size:14px}
.kz-lado{flex:1 1 48%;display:flex;align-items:center;justify-content:center;padding:32px 20px}
.kz-caixa{width:100%;max-width:400px;background:#fff;border-radius:18px;box-shadow:0 12px 40px rgba(15,23,42,.10);padding:40px 36px}
.kz-caixa h2{margin:0 0 6px;font-size:26px;color:#0f172a}
.kz-caixa .kz-sub2{margin:0 0 28px;font-size:14px;color:#64748b}
.kz-caixa label{font-size:13px;font-weight:600;color:#334155}
.kz-caixa input{height:46px;padding:0 14px;border-radius:10px;border:1px solid #e2e8f0;font-size:15px;outline:none;background:#f8fafc;transition:border-color .15s, box-shadow .15s;color:#0f172a !important;-webkit-text-fill-color:#0f172a;caret-color:#0f172a}
.kz-caixa input::placeholder{color:#94a3b8;-webkit-text-fill-color:#94a3b8;opacity:1}
.kz-caixa input:-webkit-autofill,.kz-caixa input:-webkit-autofill:focus{-webkit-text-fill-color:#0f172a;-webkit-box-shadow:0 0 0 1000px #f8fafc inset;transition:background-color 9999s}
.kz-caixa input:focus{border-color:var(--kz-cor);box-shadow:0 0 0 3px color-mix(in srgb,var(--kz-cor) 20%,transparent);background:#fff}
.kz-botao{height:48px;border:none;border-radius:10px;color:#fff;font-size:15px;font-weight:700;cursor:pointer;margin-top:6px;background:var(--kz-cor);transition:filter .15s}
.kz-botao:hover:not(:disabled){filter:brightness(1.1)}
.kz-botao:disabled{opacity:.6;cursor:not-allowed}
.kz-link{background:none;border:none;color:var(--kz-cor);font-size:13px;cursor:pointer;padding:4px 0;font-weight:600}
.kz-link:hover{text-decoration:underline}
.kz-rodape{margin-top:22px;font-size:12px;color:#94a3b8;text-align:center}
@media (max-width: 860px){
  .kz-login{flex-direction:column}
  .kz-painel{flex:none;padding:28px 24px 26px}
  .kz-painel img{width:min(70%,200px);max-height:64px}
  .kz-painel h1{font-size:28px;margin:18px 0 4px}
  .kz-painel p.kz-sub{font-size:14px;margin:0}
  .kz-painel ul,.kz-painel .kz-circ{display:none}
  .kz-lado{padding:20px 16px 32px;align-items:flex-start}
  .kz-caixa{padding:28px 22px;box-shadow:0 6px 24px rgba(15,23,42,.08)}
}`;

// Moldura comum às telas de login, esqueci a senha, e-mail enviado e conflito.
function Moldura({ portal, children }) {
  return (
    <div className="kz-login" style={{ '--kz-cor': portal.botao }}>
      <style>{CSS_LOGIN}</style>
      <section className="kz-painel" style={{ background: portal.fundo }}>
        <div className="kz-circ c1" /><div className="kz-circ c2" />
        <img src={logoKzero} alt="Kzero Consultoria" />
        <h1>{portal.titulo.replace(/ (\S+)$/, ' ')}<span style={{ color: portal.destaque }}>{portal.titulo.split(' ').pop()}</span></h1>
        <p className="kz-sub">{portal.subtitulo}</p>
        <ul>
          {portal.frases.map(f => <li key={f}><span className="kz-ok">✓</span>{f}</li>)}
        </ul>
      </section>
      <main className="kz-lado">
        <div className="kz-caixa">{children}</div>
      </main>
    </div>
  );
}

export function Login() {
  const portal = identidadeDoPortal();
  React.useEffect(() => { document.title = portal.aba; }, [portal.aba]);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [tela, setTela] = useState('login'); // 'login' | 'esqueci' | 'enviado' | 'conflito'
  const [emailReset, setEmailReset] = useState('');
  const [sessoesConflito, setSessoesConflito] = useState([]);
  const [salvandoSnapshot, setSalvandoSnapshot] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setCarregando(true);
    setErro('');

    // Autentica primeiro
    const { error } = await supabase.auth.signInWithPassword({ email, password: senha });
    if (error) {
      setErro('E-mail ou senha incorretos. Tente novamente.');
      setCarregando(false);
      return;
    }

    // Verifica sessões ativas em outros dispositivos
    try {
      const outras = await verificarSessoesAtivas();
      if (outras.length > 0) {
        setSessoesConflito(outras);
        setTela('conflito');
        setCarregando(false);
        // NÃO faz signOut — a sessão fica "pendente" até o usuário decidir
        // O App.jsx não renderiza enquanto tela === 'conflito' via callback
        return;
      }
    } catch {}

    setCarregando(false);
    // Login normal — App.jsx vai detectar a sessão
  };

  const handleConfirmarConflito = async () => {
    setSalvandoSnapshot(true);
    // Salva snapshot dos dados atuais na nuvem antes de prosseguir
    await salvarSnapshotConflito();
    setSalvandoSnapshot(false);
    setSessoesConflito([]);
    setTela('login');
    // Sessão já está ativa — App.jsx vai renderizar normalmente
  };

  const handleCancelarConflito = async () => {
    // Cancela — faz logout
    await supabase.auth.signOut();
    setSessoesConflito([]);
    setTela('login');
  };

  const handleEsqueci = async (e) => {
    e.preventDefault();
    setCarregando(true);
    setErro('');
    const { error } = await supabase.auth.resetPasswordForEmail(emailReset, {
      // Volta para o endereço em que o aluno está (kzerodiary.vercel.app ou
      // aluno.kzeroconsultoria.com.br), não para um domínio fixo.
      redirectTo: `${window.location.origin}/`,
    });
    if (error) {
      setErro('Erro ao enviar e-mail: ' + error.message);
    } else {
      setTela('enviado');
    }
    setCarregando(false);
  };

  if (tela === 'conflito') {
    return (
      <Moldura portal={portal}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>
          <h2 style={{ color: '#b45309' }}>Sessão ativa detectada</h2>
          <p className="kz-sub2" style={{ marginBottom: 16, lineHeight: 1.5 }}>
            Você já está logado em outro dispositivo. Para evitar perda de dados,
            vamos <strong>salvar um backup</strong> do estado atual antes de continuar.
          </p>
          <div style={{ background: '#fef3c7', border: '1px solid #f59e0b', borderRadius: 8, padding: '12px 16px', marginBottom: 20, textAlign: 'left', fontSize: 13 }}>
            <strong>Dispositivos ativos:</strong>
            {sessoesConflito.map((s, i) => (
              <div key={i} style={{ marginTop: 6, color: '#92400e' }}>
                {s.device_info || 'Dispositivo desconhecido'} — ativo {new Date(s.last_seen).toLocaleString('pt-BR')}
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <button
              className="kz-botao"
              onClick={handleConfirmarConflito}
              disabled={salvandoSnapshot}
              style={{ background: '#b45309' }}
            >
              {salvandoSnapshot ? 'Salvando backup...' : 'Salvar backup e continuar'}
            </button>
            <button onClick={handleCancelarConflito} className="kz-link">
              Cancelar login
            </button>
          </div>
      </Moldura>
    );
  }

  if (tela === 'enviado') {
    return (
      <Moldura portal={portal}>
          <h2>E-mail enviado!</h2>
          <p className="kz-sub2" style={{ lineHeight: 1.5 }}>
            Verifique sua caixa de entrada em <strong>{emailReset}</strong> e clique no link para redefinir sua senha.
          </p>
          <button className="kz-botao" style={{ width: '100%' }} onClick={() => { setTela('login'); setEmailReset(''); }}>
            Voltar ao login
          </button>
      </Moldura>
    );
  }

  if (tela === 'esqueci') {
    return (
      <Moldura portal={portal}>
          <h2>Redefinir senha</h2>
          <p className="kz-sub2">
            Informe seu e-mail e enviaremos um link para redefinir sua senha.
          </p>
          <form onSubmit={handleEsqueci} style={estilos.form}>
            <div style={estilos.campo}>
              <label htmlFor="kz-email-reset">E-mail</label>
              <input
                id="kz-email-reset"
                type="email"
                value={emailReset}
                onChange={(e) => setEmailReset(e.target.value)}
                placeholder="seu@email.com"
                required
                autoComplete="email"
              />
            </div>
            {erro && <p style={estilos.erro}>{erro}</p>}
            <button type="submit" disabled={carregando} className="kz-botao">
              {carregando ? 'Enviando...' : 'Enviar link de redefinição'}
            </button>
            <button type="button" className="kz-link" onClick={() => { setTela('login'); setErro(''); }}>
              Voltar ao login
            </button>
          </form>
      </Moldura>
    );
  }

  return (
    <Moldura portal={portal}>
        <h2>Entrar</h2>
        <p className="kz-sub2">Use o e-mail e a senha que você recebeu da Kzero.</p>

        <form onSubmit={handleLogin} style={estilos.form}>
          <div style={estilos.campo}>
            <label htmlFor="kz-email">E-mail</label>
            <input
              id="kz-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              autoComplete="username"
            />
          </div>

          <div style={estilos.campo}>
            <label htmlFor="kz-senha">Senha</label>
            <input
              id="kz-senha"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />
          </div>

          {erro && <p style={estilos.erro}>{erro}</p>}

          <button type="submit" disabled={carregando} className="kz-botao">
            {carregando ? 'Entrando...' : 'Entrar'}
          </button>
          <button type="button" className="kz-link" onClick={() => { setTela('esqueci'); setErro(''); setEmailReset(email); }}>
            Esqueci minha senha
          </button>
        </form>
        <p className="kz-rodape">Kzero Consultoria · Consultoria para Sistemas de Gestão</p>
    </Moldura>
  );
}

const estilos = {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  campo: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    gap: '6px',
  },
  erro: {
    color: '#dc2626',
    background: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: '8px',
    padding: '8px 12px',
    fontSize: '13px',
    margin: '0',
  },
};
